import { Commercial } from "./commercials.model";
import { Customer } from "./customers.model";
import { NatureFollowerProject } from "./nature-follower-project.model";
import { Project } from "./projects.model";

export class FollowerProject {
  id: number;
  object: string;
  note: string;
  createAt: Date;
  status: string;
  project: Project;
  commercial: Commercial;
  customer: Customer;
  natureFollower: NatureFollowerProject;

  constructor() {
    this.project = new Project();
    this.commercial = new Commercial();
    this.customer = new Customer();
    this.natureFollower = new NatureFollowerProject();
  }
}

export class FollowerProjectForm {
  id: number;
  object: string;
  note: string;
  createAt: Date;
  status: string;
  project: number;
  commercial: number;
  customer: number;
  natureFollower: number;

  constructor() { }
}
